/**
 * KLOKI – odpočet v BTS promo liště (HP, vybraná PDP i BTS LP).
 *
 * Cíl je ABSOLUTNÍ okamžik v data-bts-until (epocha v sekundách, spočítaná
 * Liquidem v časovém pásmu obchodu). Záměrně se NEČTE `2026-09-01T23:59`
 * přímo v prohlížeči — new Date() by to vzalo jako místní čas návštěvníka
 * a mimo středoevropské pásmo by odpočet skončil v jinou chvíli.
 *
 * Šablona vykreslí správné číslice už na serveru, tenhle skript je jen
 * dopočítává. Když se nenačte, zůstane platný stav z okamžiku renderu.
 * Protože Shopify část stránek servíruje z cache bez re-renderu, může být
 * server-side hodnota zastaralá — proto se hned při startu přepočítá.
 *
 * Po vypršení se prvek odstraní (na cachované stránce se může vykreslit
 * i po termínu, server-side pojistka na to nestačí).
 */
(function () {
  'use strict';

  function dva(n) { return n < 10 ? '0' + n : String(n); }

  function tik(el) {
    var until = parseInt(el.getAttribute('data-bts-until'), 10);
    if (!until) return true;
    var zbyva = until - Math.floor(Date.now() / 1000);

    if (zbyva <= 0) {
      if (el.parentNode) el.parentNode.removeChild(el);
      return true;
    }

    var dny = Math.floor(zbyva / 86400);
    var zbytek = zbyva % 86400;
    var hod = Math.floor(zbytek / 3600);
    var min = Math.floor((zbytek % 3600) / 60);
    var sek = zbytek % 60;

    var elDny = el.querySelector('[data-bts-cd-days]');
    var elCas = el.querySelector('[data-bts-cd-clock]');

    if (elDny) {
      if (dny > 0) {
        var cislo = elDny.querySelector('[data-bts-cd-days-num]');
        if (cislo && cislo.textContent !== String(dny)) cislo.textContent = String(dny);
        var popisek = elDny.querySelector('[data-kl-dny]');
        if (popisek) popisek.textContent = (dny === 1) ? popisek.getAttribute('data-d1')
                                         : (dny <= 4)  ? popisek.getAttribute('data-d2')
                                                       : popisek.getAttribute('data-d5');
        elDny.hidden = false;
      } else {
        elDny.hidden = true;
      }
    }
    if (elCas) {
      var text = dva(hod) + ':' + dva(min) + ':' + dva(sek);
      if (elCas.textContent !== text) elCas.textContent = text;
    }

    var popis = el.getAttribute('data-bts-cd-label') || '';
    el.setAttribute('aria-label', popis + ' ' + (dny > 0 ? dny + ' / ' : '') + dva(hod) + ':' + dva(min) + ':' + dva(sek));
    return false;
  }

  function start() {
    var prvky = document.querySelectorAll('[data-bts-countdown]');
    if (!prvky.length) return;

    prvky.forEach(function (el) {
      if (el.__btsCd) return;
      el.__btsCd = true;
      if (tik(el)) return;
      el.__btsCdTimer = setInterval(function () {
        if (tik(el) && el.__btsCdTimer) clearInterval(el.__btsCdTimer);
      }, 1000);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
  /* Návrat na kartu po delší době ve spánku: dopočítat hned, ne až za sekundu. */
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) {
      document.querySelectorAll('[data-bts-countdown]').forEach(tik);
    }
  });
})();
